import assertString from "./util/assertString";

export default function test(str, pattern) {
    assertString(str);

    if (Object.prototype.toString.call(pattern) === '[object Array]')
        pattern = pattern[0];

    if (Object.prototype.toString.call(pattern) !== '[object RegExp]') {
        pattern = new RegExp(pattern);
    }

    return pattern.test(str);
}
